import * as navStyles from '../../../styles/layout/transversal-nav-nojs.module.scss';
import PropTypes from 'prop-types';
import React, {useEffect} from 'react';
import {
  displayAriaLabelLanguages,
  displayLanguages,
  handleLanguageSelection
} from '../../../utils/parsing';

import IconContainer from '../../shared/IconContainer';
import Modal from 'react-modal';
import NestedItemHtml from '../NestedItemHtml';
import SearchPopUp from '../SearchPopUp';
import _ from 'lodash';
import clsx from 'clsx';
import {toExternalUrl} from '../../../utils/utils';
import {useTranslation} from 'react-i18next';

Modal.setAppElement('body');

const TransversalNavigation = React.memo(function TransversalNavigation ({
  corporateMenu,
  localizations,
  websiteRoot,
  locale,
  themeClass,
}) {
  const siteURL = websiteRoot;
  const data = React.useMemo(() => {
    const res = [];
    if (corporateMenu?.menu?.length > 0) {
      _.flatMapDeep(corporateMenu.menu[0].items, (i) => {
        const tmp2 = _.flatMapDeep(i.target_object.menu, (m) => {
          return [
            {
              visible: m.visible,
              title: i.label,
              new_window: i.new_window,
              subMenuItems: [
                {
                  new_window: m.new_window,
                  title: m.label,
                  url: toExternalUrl(m.target_object.uid),
                },
              ],
            },
          ];
        });

        let tmp3 = null;

        if (tmp2.length === 0 && i.visible) {
          res.push({title: i.label, url: toExternalUrl(i.target_object.uid), new_window: i.new_window,});
          return;
        }
        if (tmp2.length > 1 && tmp2[0].visible) {
          tmp3 = {
            title: tmp2[0].title,
            subMenuItems: [],
          };
          _.forEach(tmp2, (el) => {
            if (el.visible)
              tmp3.subMenuItems.push(el.subMenuItems[0]);
          });
        }


        if (tmp3 !== null) {
          res.push(tmp3);
        }
      });
    }
    return res;
  }, [corporateMenu?.menu]);
  const {t} = useTranslation();
  const [search] = React.useState(false);

  const otherLanguage = localizations?.length > 0 ? localizations[0] : null;

  let displayLang = '';
  if (otherLanguage && otherLanguage.locale) {
    displayLang = otherLanguage.locale.toLowerCase();
  }

  const displayedLanguage = displayLanguages(otherLanguage);
  const ariaLabel = displayAriaLabelLanguages(otherLanguage);
  const linkToOtherLanguage = handleLanguageSelection(siteURL, otherLanguage);
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'initial';
    }
  }, [open]);

  const ref = React.useRef(null);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleOpen();
    }
  };
  return (
    <>
      <Modal
        aria-labelledby="modal-modal-title"
        className={clsx(navStyles.modal, themeClass)}
        isOpen={open}
        overlayClassName={clsx(navStyles.overlay, themeClass)}
      >
        <SearchPopUp
          handleClose={handleClose}
          language={locale}
          websiteRoot={websiteRoot}
        />
      </Modal>
      <div className={navStyles.wrapperMenu}>
        <div className={navStyles.dropdownHeader}>
          <div id={'navigationTransversal'}>
            <ul>
              <li
                className={clsx(navStyles.list, navStyles.dropdownCategories)}
                ref={ref}
              >
                <NestedItemHtml maref={ref}
                  menu={data}
                />
              </li>
            </ul>
          </div>
          <div className={navStyles.rightItems}>
            <div
              aria-label={t('search.window.open')}
              id="searchForm"
              onClick={() => {
                handleOpen();
              }}
              onKeyDown={handleKeyDown}
              role="button"
              tabIndex={0}
              title={t('header.search')}
            >
              <IconContainer color="WHITE"
                icon="SEARCH"
                notFocus
                size={20}
                tabIndex={-1}
              />
            </div>
            {search && (
              <div>
                <input
                  aria-label="Rechercher"
                  className={navStyles.search}
                />
              </div>
            )}
          </div>
          {otherLanguage && (
            <a
              aria-label={ariaLabel}
              className={`${navStyles.langButton} uppercase`}
              data-cy={`desktop-language-${displayLang}`}
              href={linkToOtherLanguage}
              lang={displayLang}
            >
              {displayedLanguage}
            </a>
          )}
        </div>
      </div>
    </>
  );
});

TransversalNavigation.propTypes = {
  corporateMenu: PropTypes.shape({
    menu: PropTypes.arrayOf(
      PropTypes.shape({
        items: PropTypes.arrayOf(
          PropTypes.shape({
            label: PropTypes.string.isRequired,
            visible: PropTypes.bool.isRequired,
            target_object: PropTypes.shape({
              menu: PropTypes.arrayOf(
                PropTypes.shape({
                  visible: PropTypes.bool.isRequired,
                  label: PropTypes.string.isRequired,
                  target_object: PropTypes.shape({
                    uid: PropTypes.string,
                  }).isRequired,
                })
              ),
              uid: PropTypes.string,
            }),
          })
        ),
      })
    ),
  }),
  locale: PropTypes.string,
  localizations: PropTypes.arrayOf(
    PropTypes.shape({
      locale: PropTypes.string,
    })
  ),
  themeClass: PropTypes.string,
  websiteRoot: PropTypes.string.isRequired,
};

export default TransversalNavigation;
